export default {
  en: {
    message: {
      component: {
        missing_recaptcha: 'Please tick "I\'m not a robot"',
        select_all: 'Select All',
        countdown: 'Please input the verification code in {0}',
        location_selector: {
          add: 'Add Location(s)',
          delete: 'Delete Location',
          predefined: 'Predefined Locations:'
        },
        crud_table: {
          leave_dialog: 'The information has not been saved, do you want to leave this page?',
          required: 'Incomplete information!'
        }
      },
      chat: {
        empty: 'No message.',
        typing: 'is typing.'
      },
      date: {
        sunday: 'Sun',
        monday: 'Mon',
        tuesday: 'Tue',
        wednesday: 'Wed',
        thursday: 'Thu',
        friday: 'Fri',
        saturday: 'Sat',
        amomentago: 'a moment ago',
        minutesago: ' minutes ago',
        hoursago: ' hours ago',
        adayago: 'a day ago',
        month: ' Month',
        day: ' Day',
        hour: ' Hour',
        minute: ' Minute'
      },
      jobtotal: 'JobTotal Limited',
      nav: {
        logout: 'Logout',
        playground: 'playground',
        about: 'About JOBTOTAL',
        search: 'Job Search',
        seeker: 'Seeker',
        employer: 'Employer',
        post: 'Post a Job',
        profile: 'Profile',
        ads: 'Job Ads',
        candidate: 'Candidates',
        talent: 'Talent',
        purchase: 'Purchase',
        billing: 'billing',
        employer_settings: 'Settings',
        seeker_site: 'Seeker Site',
        employer_site: 'Employer Site',
        org_site: 'Organization Site',
        org: 'NGO / ERB Member',
        org_management: 'Post Management',
        org_profile: 'Profile Setting',
        admin_company: 'Company',
        admin_jobfair: 'Jobfair'
      },
      search: {
        searchbar: 'Job Title, Keyword or Company',
        search_btn: 'Search',
        location: 'Work Location',
        job_type: 'Job Category',
        apply: 'apply',
        favorites: 'favorites',
        prev: 'previous',
        next: 'next',
        employment_types: 'Employment Types',
        shifts: 'Shifts'
      },
      rules: {
        eitherOne: 'Please input email or phone!',
        required: 'required 必填',
        min: 'Min {0} characters',
        email: 'Invalid e-mail.',
        phone: 'Invalid phone.',
        password_mismatch: 'Password mismatch.',
        agree: 'You must agree privacy policy and terms & conditions to complete the register.'
      },
      login: {
        or: 'OR',
        login: 'Login',
        forgot: 'Forget Password?',
        employer_login: 'Employer Login',
        register: 'Register',
        org_login: 'NGO / ERB Member Login',
        admin_login: 'Admin Login',
        email: 'Email Address',
        email_holder: 'Please enter your email address!',
        email_hint: 'It must be a valid email address.',
        password: 'Password',
        password_holder: 'Please enter your password!',
        password_hint: 'At least 6 characters.',
        phone: 'Mobile Number',
        phone_holder: 'Please enter your mobile number!',
        phone_hint: 'It must be a valid mobile number.',
        seeker_login: 'Job Seeker Login',
        forgot_title: 'Get back your Jobtotal account.',
        forgot_subtitle: 'Please enter your account information!',
        forgot_holder: 'Please enter your email or mobile phone!',
        continue: 'Continue',
        forgot_dialog: {
          phone_title: 'Confirm your phone number.',
          email_title: 'Confirm your email.',
          text: 'We will send a 6-digit verification code to:',
          footer: 'Message fees may apply to messages sent by Jobtotal',
          code_holder: 'Please input 6 digits verification code'
        }
      },
      button: {
        send: 'Send',
        confirm: 'Confirm',
        cancel: 'Cancel'
      },
      register: {
        reset: 'Reset Password',
        org_register: 'NGO / ERB Member Register',
        email: 'Email',
        email_holder: 'Please enter your email address!',
        email_hint: 'Please enter a valid email address.',
        first_name: 'First Name',
        first_name_holder: 'Please enter your first name!',
        last_name: 'Last Name',
        last_name_holder: 'Please enter your last name!',
        organization_name: 'Organization Name',
        organization_name_holder: 'Please enter your organization name!',
        phone: 'Mobile Number',
        phone_holder: 'Please enter your mobile number!',
        phone_hint: 'Please enter your mobile number.',
        password: 'Password',
        password_holder: 'Please enter your password in minimum 8 digits!',
        password_hint: 'At least 8 digits.',
        confirm_password: 'Confirm Password',
        confirm_password_holder: 'Please re-enter your password!',
        agree_hint: 'By clicking Register, you agree to accept JobTotal Limited\'s ',
        new_tab: 'Opens in new window',
        privacy: 'privacy policy',
        terms: 'terms & conditions',
        agree_and: ' and '
      },
      org: {
        register_infor: 'You have successfully registered, please fill in the profile and edit your posting. We will make a one-stop approval within two working days!',
        management: {
          title: 'Post Management',
          refresh: 'Refresh',
          new: 'New Item',
          edit: 'Edit Item',
          delete: 'Are you sure you want to delete this item?',
          empty: 'No Data',
          save: 'Save',
          update: 'Update',
          confirm: 'Confirm',
          cancel: 'Cancel',
          headers: {
            name_en: 'English Title',
            name_tc: 'Chinese Title',
            category: 'Category',
            start_date: 'Start Date',
            end_date: 'End Date',
            fee: 'Fee',
            actions: 'Actions'
          },
          footer: {
            rows_per_page: 'Rows per page:'
          },
          post: {
            name_en: 'English Title',
            name_tc: 'Chinese Title',
            category_id: 'Category',
            post_date: 'Post Date',
            start_date: 'Start Date',
            end_date: 'End Date',
            start_time: 'Start Time',
            end_time: 'End Time',
            fee: 'Fee',
            url: 'Website(URL)',
            description_en: 'English Introduction',
            description_tc: 'Chinese Introduction',
            locations: 'Locations',
            locations_sub: 'At least enter one location',
            required: 'Please enter all required information!'
          }
        },
        profile: {
          title: 'Profile Settings',
          subtitle: 'Update Information',
          update: 'Update',
          cancel: 'Reset',
          email: 'Email',
          name_en: 'English Name',
          name_tc: 'Chinese Name',
          phone: 'Phone',
          url: 'Web Site (URL)',
          logo: 'Organization Logo',
          description_en: 'English Introduction',
          description_tc: 'Chinese Introduction',
          locations: 'Center Locations*',
          locations_sub: 'At least enter one location',
          district: 'District',
          address_tc: 'Chinese Address',
          address_en: 'English Address'
        }
      },
      toast: {
        updated: 'updated',
        error: 'error occurred: {0}',
        uploaded: 'Successfully Uploaded'
      },
      admin: {
        company: {
          title: 'Company',
          new: 'New Item',
          edit: 'Edit Item',
          delete: 'Are you sure you want to delete this item?',
          empty: 'No Data',
          save: 'Save',
          update: 'Update',
          confirm: 'Confirm',
          cancel: 'Cancel',
          refresh: 'Refresh',
          headers: {
            business_name: 'Company Name',
            contact_name: 'Contact Name',
            contact_phone: 'Contact Phone',
            br_number: 'BR Number',
            verify_user: 'Verify User',
            verify_date: 'Verify Date',
            company_status_id: 'Company Status',
            company_suspension_id: 'Company Suspension Status',
            actions: 'Actions'
          },
          record: {
            display_name: 'Name',
            description: 'Description',
            company_url: 'Website Url',
            // facebook: 'facebook',
            // logo_file_id: 'logo_file_id',
            business_name: 'Name',
            br_number: 'BR Number',
            // br_file_id: 'br_file_id',
            contact_name: 'Contact Person Name',
            contact_email: 'Contact Person Email',
            contact_phone: 'Contact Phone',
            category_id: 'Category',
            company_status_id: 'Company Status',
            company_suspension_id: 'Company Suspension Status'
          }
        },
        jobfair: {
          title: 'Jobfair',
          new: 'New Job Fair',
          edit: 'Edit Job Fair',
          delete: 'Are you sure you want to delete this Job Fair?',
          empty: 'No Data',
          save: 'Save',
          update: 'Update',
          confirm: 'Confirm',
          cancel: 'Cancel',
          refresh: 'Refresh',
          company_headers: {
            name_phone: 'Name',
            post_count: 'Post Count',
            interviewer_count: 'Interviewer Count',
            status_id: 'Status',
            actions: 'Actions'
          },
          company: 'Company',
          add_company: 'Add Company',
          company_status: {
            waiting: 'Waiting',
            approve: 'Approve',
            reject: 'Reject',
            delete: 'Delete'
          },
          headers: {
            event_date: 'Event Date',
            name_en: 'Name (EN)',
            name_tc: 'Name (TC)',
            category_id: 'Category',
            status_id: 'Status',
            quota: 'Quota',
            joined_company: 'Joined Company',
            actions: 'Actions'
          },
          record: {
            name_en: 'Name (EN)',
            name_tc: 'Name (TC)',
            status_id: 'Status',
            category_id: 'Category',
            quota: 'Quota',
            remark: 'Remark'
          }
        }
      }
    }
  },
  tc: {
    message: {
      component: {
        missing_recaptcha: '請勾選"我不是機械人"',
        select_all: '選擇全部',
        countdown: '請在{0}內輸入驗證碼',
        location_selector: {
          add: '新增地址',
          delete: '刪除地址',
          predefined: '預設地址:'
        },
        crud_table: {
          leave_dialog: '資料未作保存, 您是否要離開此頁?',
          required: '資料未齊!'
        }
      },
      chat: {
        empty: '沒有信息',
        typing: '輸入中'
      },
      date: {
        sunday: '日',
        monday: '一',
        tuesday: '二',
        wednesday: '三',
        thursday: '四',
        friday: '五',
        saturday: '六',
        amomentago: '剛剛',
        minutesago: '分鐘前',
        hoursago: '小時前',
        adayago: '一日前',
        month: '月',
        day: '日',
        hour: '時',
        minute: '分'
      },
      jobtotal: 'JobTotal Limited ',
      nav: {
        logout: '登出',
        playground: '測試場地',
        about: '關於JOBTOTAL',
        search: '職位搜尋',
        seeker: '求職者',
        employer: '僱主',
        post: '進行招聘',
        profile: '個人檔案',
        ads: '招聘列表',
        candidate: '求職者',
        talent: '搜尋人才',
        purchase: '購買',
        billing: '賬單',
        employer_settings: '帳戶設定',
        seeker_site: '求職頁面',
        employer_site: '僱主頁面',
        org_site: '機構頁面',
        org: 'NGO / ERB 會員',
        org_management: '管理項目',
        org_profile: '資料設定',
        admin_company: '公司',
        admin_jobfair: '招聘會'
      },
      search: {
        searchbar: '職位名稱, 關鍵字或公司名稱',
        search_btn: '搜尋',
        location: '工作地點',
        job_type: '工作類別',
        apply: '申請',
        favorites: '收藏',
        prev: '上一份',
        next: '下一份',
        employment_types: '聘用形式',
        shifts: '更份'
      },
      rules: {
        eitherOne: '請輸入電郵或電話號碼！',
        required: 'required 必填',
        min: '最少 {0} 個字符',
        email: '電郵地址不正確',
        phone: '電話號碼不正確',
        password_mismatch: '密碼不一致',
        agree: '您必須同意隱私政策和條款及細則才可以完成註冊'
      },
      login: {
        or: '或',
        login: '登入',
        forgot: '忘記密碼?',
        employer_login: '僱主登入',
        register: '註冊',
        org_login: 'NGO / ERB 會員登入',
        admin_login: 'Admin 登入',
        email: '電郵地址',
        email_holder: '請輸入您的電郵地址！',
        email_hint: '必須為可使用的電郵地址',
        password: '密碼',
        password_holder: '請輸入您的密碼！',
        password_hint: '最少6個字符',
        phone: '手機號碼',
        phone_holder: '請輸入您的手機號碼！',
        phone_hint: '必須為可使用的移動電話號碼',
        seeker_login: '求職者登入',
        forgot_title: '取回您的Jobtotal賬號',
        forgot_subtitle: '請提供我們有關您帳號的資訊',
        forgot_holder: '請輸入您的電子郵件或電話號碼',
        continue: '繼續',
        forgot_dialog: {
          phone_title: '請確認你的電話號碼！',
          email_title: '請確認你的電郵地址！',
          text: '我們將會發送6位驗證碼到：',
          footer: '短信費用將由Jobtotal支付',
          code_holder: '請輸入6位驗證碼'
        }
      },
      button: {
        send: '發送',
        confirm: '確認',
        cancel: '取消'
      },
      register: {
        reset: '重設密碼',
        org_register: 'NGO / ERB 會員註冊',
        email: '電郵地址',
        email_holder: '請輸入您的電郵地址！',
        // name: '名稱',
        // name_holder: '請輸入您的全名！',
        first_name: '名字',
        first_name_holder: '請輸入您的名字！',
        last_name: '姓氏',
        last_name_holder: '請輸入您的姓氏！',
        organization_name: 'NGO / ERB 會員註冊',
        organization_name_holder: '請輸入您的機構名稱！',
        phone: '手機號碼',
        phone_holder: '請輸入您的手機號碼！',
        phone_hint: '請輸入您的手機號碼',
        password: '密碼',
        password_holder: '請輸入至少8位數字的密碼！',
        password_hint: '最少8位數字的密碼',
        confirm_password: '再次輸入密碼',
        confirm_password_holder: '請重新輸入您的密碼！',
        agree_hint: '按下「註冊」代表您已經閱讀並接受JobTotal Limited的 ',
        new_tab: '開新視窗',
        privacy: '隱私政策',
        terms: '條款及細則',
        agree_and: '和'
      },
      org: {
        register_infor: '您已成功註冊, 請隨即輸入帳戶資料及編輯發佈內容. 我們會於兩個工作天內作出一次性的審批! ',
        management: {
          title: '管理項目',
          refresh: '重新載入',
          new: '新增項目',
          edit: '修改項目',
          delete: '你確定要刪除該項目嗎？',
          empty: '沒有项目',
          save: '保存',
          update: '更新',
          confirm: '確認',
          cancel: '取消',
          headers: {
            name_en: '英文名稱',
            name_tc: '中文名稱',
            category: '分類',
            start_date: '開始日期',
            end_date: '結束日期',
            fee: '費用',
            actions: '操作'
          },
          footer: {
            rows_per_page: '每頁顯示:'
          },
          post: {
            name_en: '英文標題',
            name_tc: '中文標題',
            category_id: '分類',
            post_date: '發佈日期',
            start_date: '開始日期',
            end_date: '結束日期',
            start_time: '開始時間',
            end_time: '結束時間',
            fee: '費用',
            url: '網址(URL)',
            description_en: '英文簡介',
            description_tc: '中文簡介',
            locations: '中心地址',
            locations_sub: '最少輸入1個地址',
            required: '請輸入所有必須填寫的資訊!'
          }
        },
        profile: {
          title: '簡介資料',
          subtitle: '更新資料',
          update: '更新',
          cancel: '重置',
          email: '電郵',
          name_en: '英文名稱',
          name_tc: '中文名稱',
          phone: '電話',
          url: '網址 (URL)',
          logo: '機構徽標',
          description_en: '英文介紹',
          description_tc: '中文介紹',
          locations: '中心地址*',
          locations_sub: '最少輸入1個地址',
          district: '地區',
          address_tc: '中文地址',
          address_en: '英文地址'
        }
      },
      toast: {
        updated: '成功更新',
        error: '發生錯誤: {0}',
        uploaded: '成功上傳'
      },
      admin: {
        company: {
          title: '公司',
          new: '新公司',
          edit: '修改公司',
          delete: '請問確認刪除該公司嗎?',
          empty: '沒有資料',
          save: '儲存',
          update: '更新',
          confirm: '確認',
          cancel: '取消',
          refresh: '刷新',
          headers: {
            business_name: '公司名',
            contact_name: '聯絡人姓名',
            contact_phone: '聯絡電話',
            br_number: 'BR號碼',
            company_status_id: '公司狀態',
            company_suspension_id: '公司暫停狀態',
            actions: '操作'
          },
          record: {
            display_name: '名字',
            description: '描述',
            company_url: '網頁Url',
            // facebook: 'facebook',
            // logo_file_id: 'logo_file_id',
            business_name: '名字',
            br_number: 'BR號碼',
            // br_file_id: 'br_file_id',
            contact_name: '聯絡人姓名',
            contact_email: '聯絡電郵',
            contact_phone: '聯絡電話',
            category_id: '分類',
            company_status_id: '公司狀態',
            company_suspension_id: '公司暫停狀態'
          }
        },
        jobfair: {
          title: '招聘會',
          new: '新招聘會',
          edit: '修改招聘會',
          delete: '請問確認刪除該招聘會嗎?',
          empty: '沒有資料',
          save: '儲存',
          update: '更新',
          confirm: '確認',
          cancel: '取消',
          refresh: '刷新',
          company: '公司',
          add_company: '新增公司',
          company_status: {
            waiting: '等待中',
            approve: '批准',
            reject: '拒絕',
            delete: '刪除'
          },
          company_headers: {
            name_phone: '公司名稱',
            post_count: '刊登廣告總數',
            interviewer_count: '面試官總數',
            status_id: '狀態',
            actions: '操作'
          },
          headers: {
            event_date: '舉行日期',
            name_en: '英文名',
            name_tc: '中文名',
            category_id: '分類',
            status_id: '招聘會狀態',
            quota: '名額',
            joined_company: '已參加公司',
            actions: '操作'
          },
          record: {
            name_en: '英文名',
            name_tc: '中文名',
            status_id: '招聘會狀態',
            category_id: '分類',
            quota: '名額',
            remark: '備注'
          }
        }
      }
    }
  }
}
